import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';

const Services = () => {
  const openWhatsAppForService = (serviceName) => {
    const whatsappNumber = '917984364765';
    const message = `Hi, I want to book an appointment for ${serviceName}. Please let me know your available slots and pricing details.`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const openWhatsAppConsultation = () => {
    const whatsappNumber = '917984364765';
    const message = `Hi, I want to book a free consultation with your expert dermatologists. Please let me know your available slots for personalized recommendations.`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };
  const serviceCategories = [
    {
      category: "🌟 Skin Treatments",
      services: [
        {
          id: 1,
          title: "Skin Glow Treatment",
          description: "Achieve radiant, glowing skin with our advanced skin brightening therapy.",
          image: "/images/services/skin_glow.png",
          features: ["Instant Glow", "Deep Hydration", "Natural Results"]
        },
        {
          id: 2,
          title: "Acne Treatment",
          description: "Clear your skin with our comprehensive acne treatment protocols.",
          image: "/images/services/acne_treatment.png",
          features: ["Deep Cleansing", "Bacteria Control", "Prevention"]
        },
        // {
        //   id: 3,
        //   title: "Acne Scar Treatment",
        //   description: "Remove acne scars and restore smooth skin texture with advanced techniques.",
        //   image: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        //   features: ["Scar Reduction", "Skin Resurfacing", "Texture Improvement"]
        // },
        {
          id: 4,
          title: "Pigmentation Treatment",
          description: "Even out skin tone and reduce dark spots with targeted pigmentation therapy.",
          image: "/images/services/pigmentation.png",
          features: ["Even Skin Tone", "Dark Spot Removal", "Brightening"]
        },
        {
          id: 5,
          title: "Open Pores Treatment",
          description: "Minimize enlarged pores for smoother, refined skin texture.",
          image: "/images/services/open_pores.png",
          features: ["Pore Minimization", "Skin Tightening", "Smooth Texture"]
        },
        {
          id: 6,
          title: "Anti-Aging Treatment",
          description: "Turn back time with our comprehensive anti-aging solutions.",
          image: "/images/services/anti_aging.png",
          features: ["Wrinkle Reduction", "Skin Firming", "Youthful Glow"]
        }
      ]
    },
    {
      category: "💉 Hair Treatments",
      services: [
        {
          id: 7,
          title: "Hair Fall Treatment",
          description: "Stop hair loss and promote healthy hair growth with proven treatments.",
          image: "/images/services/hair_fall.png",
          features: ["Hair Growth", "Scalp Health", "Thickness Boost"]
        },
        {
          id: 8,
          title: "Hair PRP Therapy",
          description: "Platelet-rich plasma therapy for natural hair regeneration and growth.",
          image: "/images/services/hair_prp.png",
          features: ["Natural Growth", "PRP Technology", "Safe Treatment"]
        },
        {
          id: 9,
          title: "Face PRP for Skin Glow",
          description: "Rejuvenate your skin with PRP therapy for natural glow and texture.",
          image: "/images/services/face_prp.png",
          features: ["Natural Glow", "Skin Renewal", "Collagen Boost"]
        },
        {
          id: 10,
          title: "Vitamin Therapy",
          description: "Nourish your skin and hair with targeted vitamin infusion therapy.",
          image: "/images/services/vitamin_therapy.png",
          features: ["Deep Nourishment", "Vitamin Infusion", "Health Boost"]
        }
      ]
    },
    {
      category: "⚡ Laser Services",
      services: [
        {
          id: 11,
          title: "Laser Hair Removal",
          description: "Permanent hair reduction for full body, face, or specific areas using advanced laser technology.",
          image: "/images/services/laser_hair_removal.png",
          features: ["Permanent Results", "All Body Areas", "Safe Technology"]
        },
        {
          id: 12,
          title: "Tattoo Removal",
          description: "Remove unwanted tattoos safely with Active Pico Laser technology.",
          image: "/images/services/tattoo_removal.png",
          features: ["Pico Laser", "Safe Removal", "Minimal Scarring"]
        },
        {
          id: 13,
          title: "Mole Removal",
          description: "Safe and effective mole removal with minimal scarring.",
          image: "/images/services/mole_removal.png",
          features: ["Safe Procedure", "Minimal Scarring", "Quick Recovery"]
        },
        {
          id: 14,
          title: "Wart Removal",
          description: "Remove warts effectively with advanced laser treatment.",
          image: "/images/services/wart_removal.png",
          features: ["Effective Treatment", "Quick Procedure", "No Recurrence"]
        },
        {
          id: 15,
          title: "Skin Tag Removal",
          description: "Painless removal of skin tags with precision laser technology.",
          image: "/images/services/skin_tag_removal.png",
          features: ["Painless", "Precision Treatment", "No Scarring"]
        }
      ]
    },
    {
      category: "❄️ Fat & Body Contouring",
      services: [
        {
          id: 16,
          title: "Cool Sculpting (Cryolipolysis)",
          description: "Non-invasive fat reduction using advanced cryolipolysis technology.",
          image: "/images/services/cool_sculpting.png",
          features: ["Non-Invasive", "Fat Reduction", "No Downtime"]
        },
        {
          id: 17,
          title: "Fat Loss Treatment",
          description: "Targeted fat loss treatments for body contouring and shaping.",
          image: "/images/services/fat_loss.png",
          features: ["Body Contouring", "Targeted Fat Loss", "Visible Results"]
        },
        {
          id: 18,
          title: "Weight Loss Treatment & Counseling",
          description: "Comprehensive weight loss programs with professional counseling support.",
          image: "/images/services/weight_loss.png",
          features: ["Professional Guidance", "Sustainable Results", "Health Monitoring"]
        },
        {
          id: 19,
          title: "10D Lipo Contouring",
          description: "Advanced 10D lipo technology for precise body contouring and fat reduction.",
          image: "/images/services/10d_lipo.png",
          features: ["Advanced Technology", "Precise Contouring", "Effective Results"]
        }
      ]
    }
  ];

  // Flatten all services for the grid display
  const allServices = serviceCategories.flatMap(category => category.services);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section id="services" className="services section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="section-header"
        >
          <h2 className="section-title">Our Premium Services</h2>
          <p className="section-subtitle">
            Discover our comprehensive range of advanced skincare treatments designed to enhance your natural beauty and boost your confidence.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="services-grid"
        >
          {allServices.map((service) => (
            <motion.div
              key={service.id}
              variants={itemVariants}
              className="service-card"
              whileHover={{ y: -10 }}
              transition={{ duration: 0.3 }}
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <button className="btn-primary">Learn More</button>
                </div>
              </div>

              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>

                <div className="service-details">
                  <div className="service-meta">
                    <span className="service-price">{service.price}</span>
                    <span className="service-duration">{service.duration}</span>
                  </div>

                  <ul className="service-features">
                    {service.features.map((feature, index) => (
                      <li key={index}>✓ {feature}</li>
                    ))}
                  </ul>
                </div>

                <button className="btn-secondary service-btn" onClick={() => openWhatsAppForService(service.title)}>Book Now</button>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="services-cta"
        >
          <div className="cta-content">
            <h3>Not Sure Which Treatment is Right for You?</h3>
            <p>Book a free consultation with our expert dermatologists to get personalized recommendations.</p>
            <button className="btn-primary" onClick={openWhatsAppConsultation}>Free Consultation</button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
